module.exports = __webpack_public_path__ + "signup-bkg.jpg";